module.exports = __webpack_public_path__ + "static/img/earn-small.d210f844.png";